export default __webpack_public_path__ + "static/media/Version (2) - Prisoner of Azkaban_12.3f06c31b.jpg";